module.exports = __webpack_public_path__ + "static/media/credit-card.b61cea58.gif";